import styled from "styled-components";

export const USSafeToPlayLabelBox = styled.span`
        font-size: 12px;
        margin-right: 8px;
        
        @media ${({theme}) =>  theme.mediaQuery.sAndBelow} {
            font-size: 11px;
        }
`